module.exports = __webpack_public_path__ + "img/020022.9f6ad8bf.png";